import { NgModule } from '@angular/core';
import { Routes, RouterModule,UrlMatcher, UrlSegment } from '@angular/router';
import { SignupComponent } from './landing/signup/signup.component';
import { SigninComponent } from './landing/signin/signin.component';
import { RecoverPasswordComponent } from './landing/recover-password/recover-password.component';
import { ChangePasswordComponent } from './landing/change-password/change-password.component';
import { LandingComponent } from './landing/landing.component';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { EmailConfirmedComponent } from './landing/email-confirmed/email-confirmed.component';
import { CalendarComponent } from './home/calendar/calendar.component';
import { SubmissionsComponent } from './home/submissions/submissions.component';
import { ReviewsComponent } from './home/reviews/reviews.component';
import { ReviewViewComponent } from './component/review-view/review-view.component';
import { CommitteesComponent } from './home/committees/committees.component';
import { SessionChairingsComponent } from './home/session-chairings/session-chairings.component';
import { PublicationChairingsComponent } from './home/publication-chairings/publication-chairings.component';
import { MyEventsComponent } from './home/my-events/my-events.component';
import { EventsComponent } from './home/events/events.component';
import { AboutComponent } from './home/about/about.component';
import { AboutV2Component } from './home/about-v2/about-v2.component';
import { HelpComponent } from './home/help/help.component';
import { SettingsComponent } from './home/settings/settings.component';
import { AuthGuard } from './guard/auth.guard';
import { RedirectGuard } from './guard/redirect.guard';
import { SubmissionViewComponent } from './component/submission-view/submission-view.component';
import { PresentationCertificateComponent } from './component/presentation-certificate/presentation-certificate.component';
import { SubmissionFormViewComponent } from './component/submission-form-view/submission-form-view.component';
import { CreateSubmissionComponent } from './component/create-submission/create-submission.component';
import { ReviewFormComponent } from './component/review-form/review-form.component';
import { EventViewComponent } from './component/event-view/event-view.component';
import { EventBySlugResolver } from './resolver/event-by-slug.resolver';
import { EventAdminComponent } from './admin/event-admin/event-admin.component';
import { EventSubmissionsComponent } from './admin/event-admin/event-submissions/event-submissions.component';
import { EventSettingsComponent } from './admin/event-admin/event-settings/event-settings.component';
import { EventPeopleComponent } from './admin/event-admin/event-people/event-people.component';
import { SearchResultsInEventComponent } from './admin/event-admin/search-results-in-event/search-results-in-event.component';
import { AdminEventViewComponent } from './admin/event-admin/event-view/event-view.component';
import { SearchResultsComponent } from './home/search-results/search-results.component';
import { AdminEventCreateComponent } from './admin/events/create-event/create-event.component';
import { AdminGuard } from './guard/admin.guard';
import { ErrorViewComponent } from './component/error-view/error-view.component';
import { RequestEventComponent } from './home/request/event/event.component';
import { SignoutComponent } from './landing/signout/signout.component';
import { LoadingComponent } from './home/loading/loading.component';
import { CheckEventComponent } from './component/check-event/check-event.component';
import { AdminLandingComponent } from './admin/landing/landing.component';
import { AdminEventRequestComponent } from './admin/event-requests/request/request.component';
import { SubmissionEditComponent } from './component/submission-edit/submission-edit.component';
import { EventSettingsEmailComponent } from './admin/event-admin/event-settings/event-settings-email/event-settings-email.component';
import { ActivateEmailComponent } from './landing/activate-email/activate-email.component';
import { EventTopicsComponent } from './admin/event-admin/event-settings/event-topics/event-topics.component';
import { EventChairsComponent } from './admin/event-admin/event-people/event-chairs/event-chairs.component';
import { EventTracksComponent } from './admin/event-admin/event-settings/event-tracks/event-tracks.component';
import { EventTracksEditComponent } from './component/event-tracks-edit/event-tracks-edit.component';
import { EventMembersComponent } from './admin/event-admin/event-people/event-members/event-members.component';
import { EventSendEmailComponent } from './admin/event-admin/event-people/event-send-email/event-send-email.component';
import { AdminCreateSubmissionComponent } from './component/admin-create-submission/admin-create-submission.component';
import { AdminSubmitSelectTrackComponent } from './admin/event-admin/admin-submit-select-track/admin-submit-select-track.component';
import { ReviewsConfigurationComponent } from './admin/event-admin/event-reviews/reviews-configuration/reviews-configuration.component';
import { PaperGroupsComponent } from './admin/event-admin/event-settings/paper-groups/paper-groups.component';
import { EventFormsComponent } from './admin/event-admin/event-settings/event-forms/event-forms.component';
import { TPCGroupsComponent } from './admin/event-admin/event-settings/tpc-groups/tpc-groups.component';
import { ChairOrAdminGuard } from './guard/chair-admin.guard';
import { ReportPrintingProblemComponent } from './component/report-printing-problem/report-printing-problem.component';
import { UserEventTopicsComponent } from './home/user-event-topics/user-event-topics.component';
import { EventUserTopicsComponent } from './admin/event-admin/event-people/event-user-topics/event-user-topics.component';
import { PreviewFormComponent } from './admin/event-admin/event-settings/event-forms/preview-form/preview-form.component';
import { UserViewComponent } from './admin/event-admin/event-people/user-view/user-view.component';
import { PaperReviewHistoryComponent } from './component/paper-review-history/paper-review-history.component';
import { SubmissionHistoryComponent } from './component/submission-history/submission-history.component';
import { ConflictInterestComponent } from './home/conflict-interest/conflict-interest.component';
import { MissingManuscriptsComponent } from './admin/event-admin/event-settings/missing-manuscripts/missing-manuscripts.component';
import { ReviewStatusPerSubmissionComponent } from './admin/event-admin/event-reviews/review-status-per-submission/review-status-per-submission.component';
import { ReviewStatusPerUserComponent } from './admin/event-admin/event-reviews/review-status-per-user/review-status-per-user.component';
import { ConfirmReviewComponent } from './landing/confirm-review/confirm-review.component';
import { ConfirmTPCInviteRedirectComponent } from './landing/confirm-tpcinvite-redirect/confirm-tpcinvite-redirect.component';
import { AdminNotifyReviewersComponent } from './admin/event-admin/event-reviews/notify-reviewers/notify-reviewers.component';
import { ClaimReviewComponent } from './component/claim-review/claim-review.component';
import { SubmissionRankingComponent } from './admin/event-admin/event-submissions/submission-ranking/submission-ranking.component';
import { AuthorsListComponent } from './admin/event-admin/event-submissions/authors-list/authors-list.component';
import { EventExtraFeatureGuard } from './guard/event-extra-feature.guard';
import { SubmissionsUploadComponent } from './admin/event-admin/event-submissions/submissions-upload/submissions-upload.component';
import { ReviewsUploadComponent } from './admin/event-admin/event-reviews/reviews-upload/reviews-upload.component';
import { AssignReviewSuggestionComponent } from './admin/event-admin/event-reviews/assign-review-suggestion/assign-review-suggestion.component';
import { AdminNotifyAuthorsComponent } from './admin/event-admin/event-submissions/notify-authors/notify-authors.component';
import { SubmissionFilesComponent } from './admin/event-admin/event-submissions/submission-files/submission-files.component';
import { AdminBibtexExportComponent } from './admin/event-admin/event-submissions/bibtex-export/bibtex-export.component';
import { CertificateTemplateEditorComponent } from './admin/event-admin/event-submissions/certificate-template/certificate-template-editor.component';
import { FindReviewersByInterestComponent } from './component/find-reviewers-by-interest/find-reviewers-by-interest.component';
import { EventProgramComponent } from './admin/event-admin/event-sessions/program/event-program.component';
import { EmailStatusComponent } from './admin/event-admin/event-settings/email-status/email-status.component';
import { RouteTitleGuard } from './guard/route-title.guard';
import { UnsavedChangesGuard } from './guard/unsaved-changes.guard';
import { AdminEventWizardComponent } from './admin/event-admin/event-wizard/event-wizard.component';
import { UserDashboardComponent } from './home/user-dashboard/user-dashboard.component';
import { CalendarViewComponent } from './admin/event-admin/event-sessions/calendar-view/calendar-view.component';
import { IeeeElectronicCopyrightComponent } from './component/ieee-electronic-copyright/ieee-electronic-copyright.component';
import { SubmissionStatisticsComponent } from './admin/event-admin/event-submissions/submission-statistics/submission-statistics.component';
import { EventPublicationComponent } from './admin/event-admin/event-publication/event-publication/event-publication.component';
import { EventPublicationProceedingsComponent } from './admin/event-admin/event-publication/event-publication-proceedings/event-publication-proceedings.component';
import { NotifyPendingsComponent } from './component/notify-pendings/notify-pendings.component';
import { ExportSubmissionsComponent } from './admin/event-admin/event-submissions/export-submissions/export-submissions.component';
import { ExportSubmissionsChooserComponent } from './admin/event-admin/event-submissions/export-submissions-chooser/export-submissions-chooser.component';
import { DeletedSubmissionsComponent } from './component/deleted-submissions/deleted-submissions.component';
// Seções da administração global (`/admin`) — antes abas de um mat-tab-group
// em admin/landing, agora rotas próprias dirigidas pelo app-admin-sidebar.
import { AdminEventsListComponent } from './admin/events/events.component';
import { AdminEventRequestsComponent } from './admin/event-requests/event-requests.component';
import { AdminDefaultEmailTemplatesComponent } from './admin/admin-default-email-templates/admin-default-email-templates.component';
import { AdministratorsComponent } from './admin/administrators/administrators.component';
import { AdminUserSearchComponent } from './admin/user-search/user-search.component';
import { MergeUsersComponent } from './admin/merge-users/merge-users.component';
import { ProxyHistoryComponent } from './component/proxy-history/proxy-history.component';
import { AdminDeletedSubmissionsComponent } from './admin/deleted-submissions/deleted-submissions.component';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivateChild: [RedirectGuard, RouteTitleGuard],
    children: [
      { path: '', component: SigninComponent },
      { path: 'signup', component: SignupComponent },
      { path: 'recoverPassword', component: RecoverPasswordComponent },
      { path: 'changePassword/:uidb64/:token', component: ChangePasswordComponent },
      { path: 'emailConfirmed/:uidb64/:token/:userb64', component: EmailConfirmedComponent },
      { path: 'activateAccount', component: ActivateEmailComponent },
      { path: 'signout', component: SignoutComponent },
      { path: 'loading', component: LoadingComponent }
    ],
    runGuardsAndResolvers: 'always',
  },
  {
    path: '',
    component: HomeComponent,
    canActivateChild: [AuthGuard, RouteTitleGuard],
    children: [
      { path: 'calendar', component: CalendarComponent },
      { path: 'submissions', component: SubmissionsComponent },
      { path: 'submissions/:id', component: SubmissionViewComponent },
      { path: 'submissions/:submissionId/edit', component: SubmissionEditComponent },
      { path: 'submissions/:id/history', component: SubmissionHistoryComponent },
      { path: 'submissions/:id/find-reviewers-by-interest', component: FindReviewersByInterestComponent },
      { path: 'submissions/:id/review-history', component: PaperReviewHistoryComponent },
      { path: 'submissions/:id/ieeeElectronicCopyright', component: IeeeElectronicCopyrightComponent},
      { path: 'submissions/:id/extra-items', component: SubmissionFormViewComponent },
      { path: 'submissions/:id/certificate', component: PresentationCertificateComponent },
      { path: 'submissions/:id/:id', component: SubmissionViewComponent },
      { path: 'reviews', component: ReviewsComponent },
      { path: 'reviews/:id', component: ReviewViewComponent },
      { path: 'reviews/:id/create', component: ReviewFormComponent },
      { path: 'reviews/:id/edit', component: ReviewFormComponent },
      { path: 'reviews/:id/printing-problem/report', component: ReportPrintingProblemComponent },
      { path: 'reviews/:id/review-history', component: PaperReviewHistoryComponent },
      { path: 'reviews/:id/history', component: SubmissionHistoryComponent },
      { path: 'session-chairings', component: SessionChairingsComponent },
      { path: 'publication-chairings', component: PublicationChairingsComponent },
      { path: 'committees', component: CommitteesComponent },
      { path: 'my-events', component: MyEventsComponent },
      { path: 'events', component: EventsComponent },
      { path: 'events/:id', component: EventViewComponent },
      { path: 'events/:eventId/:trackId/submit', component: CreateSubmissionComponent },
      { path: 'events/:eventId/defineTopics', component: UserEventTopicsComponent },
      { path: 'events/:eventId/bidReview', component: ClaimReviewComponent },
      { path: 'about', component: AboutComponent },
      { path: 'about/:pageZero', component: AboutComponent },
      { path: 'about/:pageZero/:pageOne', component: AboutComponent },
      { path: 'about-v2', component: AboutV2Component },
      { path: 'help', component: HelpComponent },
      { path: 'help/:pageZero', component: HelpComponent },
      { path: 'help/:pageZero/:pageOne', component: HelpComponent },
      { path: 'loading', component: LoadingComponent },
      { path: 'search', component: SearchResultsComponent },
      { path: 'request/event', component: RequestEventComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'confirm/reviewSubmission/:reviewId', component: ConfirmReviewComponent },
      // Compatibilidade: link antigo em e-mails de convite. Redireciona
      // pra página do evento, onde o painel embutido aparece pra quem
      // tem convite pendente. Ver ConfirmTPCInviteRedirectComponent.
      { path: 'confirm/tpcMember/:id/:eventId', component: ConfirmTPCInviteRedirectComponent },
      { path: 'conflictInterest', component: ConflictInterestComponent },
      { path: 'dashboardHided', component: UserDashboardComponent },
      // Rota `/notifications` removida — o painel agora abre como
      // mat-dialog direto do sino (`UserNotificationsComponent
      // .openDialog()`). O `NotificationsCenterComponent` continua
      // declarado em `app.module.ts` e é usado dentro do dialog.
      {
        path: 'error',
        children: [
          { path: '', pathMatch: 'full', redirectTo: '404' },
          {
            component: ErrorViewComponent, matcher: errorMatcher
          }
        ],
      },
      // Rota amigável `/{slug}` (event.uri) — DEVE ser a ÚLTIMA filha
      // pra que todas as rotas explícitas acima matchem antes. Caminhos
      // multi-segmento (ex.: `/csbc/people`) NÃO matcham aqui (`:slug`
      // só captura UM segmento); caem no `path: '**'` global, que mantém
      // o CheckEventComponent pra rotear pro admin do evento.
      //
      // IMPORTANTE: usamos `matcher` em vez de `path: ':slug'` pra
      // EXCLUIR segmentos reservados que colidem com rotas top-level
      // (ex.: `/admin` — sem essa exclusão, `:slug` captura "admin"
      // como URI de evento e chama `byURI/admin/` no backend; a rota
      // `path: 'admin'` lá embaixo NUNCA era alcançada porque o
      // `path: ''` pai já tinha matchado).
      {
        matcher: customUrlMatcher,
        component: EventViewComponent,
        resolve: { event: EventBySlugResolver },
      },
    ],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivateChild: [AuthGuard, AdminGuard, RouteTitleGuard],
    children: [
      {
        path: '',
        component: AdminLandingComponent,
        // Shell de 2 colunas (menu lateral flush-left + conteúdo). O flag é
        // lido pelo AdminComponent pra zerar o padding centralizador do
        // `.container` (admin.component.scss) só nesta rota — as demais rotas
        // admin (about/help/settings/event/create) mantêm a coluna central.
        data: { adminFullBleed: true },
        children: [
          // `/admin` abre na primeira seção (Eventos) — paridade com a aba
          // default do antigo mat-tab-group.
          { path: '', pathMatch: 'full', redirectTo: 'events' },
          { path: 'events', component: AdminEventsListComponent },
          { path: 'event-requests', component: AdminEventRequestsComponent },
          { path: 'email-templates', component: AdminDefaultEmailTemplatesComponent },
          { path: 'administrators', component: AdministratorsComponent },
          { path: 'user-search', component: AdminUserSearchComponent },
          { path: 'merge-users', component: MergeUsersComponent },
          { path: 'proxy-history', component: ProxyHistoryComponent },
          { path: 'deleted-submissions', component: AdminDeletedSubmissionsComponent },
        ]
      },
      { path: 'about', component: AboutComponent },
      { path: 'about-v2', component: AboutV2Component },
      { path: 'help', component: HelpComponent },
      { path: 'event/create', component: AdminEventCreateComponent },
      { path: 'event/request/:id', component: AdminEventRequestComponent },
      { path: 'settings', component: SettingsComponent },
      {
        path: 'error',
        children: [
          { path: '', pathMatch: 'full', redirectTo: '404' },
          {
            component: ErrorViewComponent, matcher: errorMatcher
          }
        ],
      },
    ],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin/:eventId',
    component: EventAdminComponent,
    canActivateChild: [AuthGuard, ChairOrAdminGuard, RouteTitleGuard],
    children: [
      { path: '', component: AdminEventViewComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'submissions', component: EventSubmissionsComponent },
      { path: 'submissions/track', component: AdminSubmitSelectTrackComponent },
      { path: 'submissions/track/:trackId/submit', component: AdminCreateSubmissionComponent },
      { path: 'submissions/missing-manuscripts', component: MissingManuscriptsComponent },
      // v2 assume o `show-all` (linkado no menu do admin sidebar). Usa
      // `adminFullBleed` pra que o mat-sidenav-content zere o padding
      // lateral — sem isso, faixas brancas apareciam entre a folha e as
      // bordas do canvas.
      { path: 'submissions/export', component: ExportSubmissionsChooserComponent },
      { path: 'submissions/show-all', component: ExportSubmissionsComponent, data: { adminFullBleed: true } },
      { path: 'submissions/groups', component: PaperGroupsComponent },
      { path: 'submissions/:type/form', component: PreviewFormComponent },
      { path: 'submissions/:type/form/edit', component: EventFormsComponent },
      { path: 'submissions/:type/form/create', component: EventFormsComponent },
      { path: 'submissions/ranking', component: SubmissionRankingComponent, data: { page: 'ranking' } },
      { path: 'submissions/authors', component: AuthorsListComponent, canActivate: [EventExtraFeatureGuard],
        data: { eventFlag: 'tpcBulkCreateUsersEnable' } },
      { path: 'submissions/bulk-upload', component: SubmissionsUploadComponent, canActivate: [EventExtraFeatureGuard],
        data: { eventFlag: 'tpcBulkCreateSubmissionsEnable' } },
      { path: 'reviews/bulk-upload', component: ReviewsUploadComponent, canActivate: [EventExtraFeatureGuard],
        data: { eventFlag: 'tpcBulkAssignReviewsEnable' } },
      { path: 'submissions/notify', component: AdminNotifyAuthorsComponent },
      { path: 'submissions/notify-pending', component: NotifyPendingsComponent },
      { path: 'submissions/submission-files', component: SubmissionFilesComponent, data: { publicationChair: true } },
      { path: 'submissions/bibtex-export', component: AdminBibtexExportComponent, data: { publicationChair: true } },
      { path: 'submissions/certificate-template', component: CertificateTemplateEditorComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'submissions/statistics', component: SubmissionStatisticsComponent },
      { path: 'submissions/deleted', component: DeletedSubmissionsComponent },
      { path: 'submissions/:id/review-history', component: PaperReviewHistoryComponent },
      { path: 'submissions/:id/history', component: SubmissionHistoryComponent },
      { path: 'submissions/:id/certificate', component: PresentationCertificateComponent },
      { path: 'submissions/:id', component: SubmissionViewComponent },
      { path: 'submissions/:id/find-reviewers-by-interest', component: FindReviewersByInterestComponent },
      { path: 'reviews/configuration', component: ReviewsConfigurationComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'reviews/:type/form', component: PreviewFormComponent },
      { path: 'reviews/:type/form/edit', component: EventFormsComponent },
      { path: 'reviews/:type/form/create', component: EventFormsComponent },
      { path: 'reviews/assignment-suggestions', component: AssignReviewSuggestionComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'reviews/reviewers/notify', component: AdminNotifyReviewersComponent },
      { path: 'reviews/:id', component: ReviewViewComponent },
      { path: 'reviews/:id/printing-problem/report', component: ReportPrintingProblemComponent },
      { path: 'reviews/:id/review-history', component: PaperReviewHistoryComponent },
      { path: 'reviews/:id/history', component: SubmissionHistoryComponent },
      { path: 'people', component: EventPeopleComponent },
      { path: 'people/chairs', component: EventChairsComponent },
      { path: 'people/members', component: EventMembersComponent },
      { path: 'people/members/topics/:userId', component: EventUserTopicsComponent },
      { path: 'people/members/groups', component: TPCGroupsComponent },
      { path: 'people/:userId', component: UserViewComponent },
      { path: 'settings', component: EventSettingsComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'settings/topics', component: EventTopicsComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'settings/tracks', component: EventTracksComponent },
      { path: 'settings/tracks/:trackId/edit', component: EventTracksEditComponent },
      { path: 'settings/tracks/create', component: EventTracksEditComponent },
      { path: 'search', component: SearchResultsInEventComponent },
      { path: 'reviews/reports/statusBySubmission', component: ReviewStatusPerSubmissionComponent },
      { path: 'reviews/reports/statusByUser', component: ReviewStatusPerUserComponent },
      { path: 'checklist', component: AdminEventWizardComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'emails/send-email', component: EventSendEmailComponent },
      { path: 'emails/emailStatus', component: EmailStatusComponent },
      { path: 'emails/emailTemplates', component: EventSettingsEmailComponent, canDeactivate: [UnsavedChangesGuard] },
      { path: 'program/list', component: EventProgramComponent, data: { publicationChair: true } },
      { path: 'program/calendar', component: CalendarViewComponent, data: { publicationChair: true } },
      { path: 'program/:viewType', component: CalendarViewComponent },
      { path: 'publication', component: EventPublicationComponent, canDeactivate: [UnsavedChangesGuard], data: { publicationChair: true } },
      // Status de publicação reusa o MESMO wrapper da Lista de submissões (SubmissionRankingComponent),
      // em modo 'publication' via route data (color scheme + colunas/filtros de publicação). Uma página, dois modos.
      { path: 'publication/status', component: SubmissionRankingComponent, data: { page: 'publication', publicationChair: true } },
      { path: 'publication/proceedings', component: EventPublicationProceedingsComponent, data: { publicationChair: true } },
      {
        path: 'error',
        children: [
          { path: '', pathMatch: 'full', redirectTo: '404' },
          {
            component: ErrorViewComponent, matcher: errorMatcher
          }
        ],
      },
    ],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'error',
    component: LandingComponent,
    canActivateChild: [RouteTitleGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/error/404' },
      {
        component: ErrorViewComponent, matcher: errorMatcher
      }
    ],
    runGuardsAndResolvers: 'always'
  },
  { // Component checks if link is of event. If not, redirects to 404.
    path: '**',
    component: CheckEventComponent,
    runGuardsAndResolvers: 'always'
  }
];

export function customUrlMatcher(segments: UrlSegment[]) {
  const RESERVED = new Set(['admin']);
  if (segments.length === 1 && !RESERVED.has(segments[0].path)) {
    return { consumed: segments, posParams: { slug: segments[0] } };
  }
  return null;
}

export function errorMatcher(url: UrlSegment[]) {
  const code = url[0].path;
  url[0].parameters = ['403', '404', '500'].find(el => el === code) ? { code: String(code) } : { code: '404' };

  return ({ consumed: url });
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
